import "./CreateTemplate.css";
import EmailEditor from "react-email-editor";
import { useEffect, useRef, useState } from "react";
import uniqid from "uniqid";
import storeTemplate from "../Controller/storeTemplate";
import { useNavigate } from "react-router-dom";
import {
  AuthErrorMessages,
  ToastSuccessMessages,
} from "../../../controllers/auth/AuthErrorMessages";
export const CreateTemplate = (id = "") => {
  const navigator = useNavigate();
  const [templateId, setTemplateId] = useState("");
  useEffect(() => {
    // if (id == "") {
    const newId = uniqid() + uniqid() + uniqid();
    console.log("newId", newId);
    setTemplateId(newId);
    // } else {
    //   console.log("id", id);
    //   setTemplateId(id);
    // }
  }, []);
  const emailEditorRef = useRef(null);

  const onLoad = () => {
    // editor instance is created
    // you can load your template here;
    // const templateJson = {};
    // emailEditorRef.current.editor.loadDesign(templateJson);
  };

  const onReady = () => {
    // editor is ready
    console.log("onReady");
  };

  const handleSubmit = async () => {
    emailEditorRef.current.editor.exportHtml(async (data) => {
      const html = data.html;
      console.log("exportHtml", html);
      const dataTemp = {
        html: html,
        id: templateId,
        type: "email",
      };

      await storeTemplate(templateId, dataTemp)
        .then(() => {
          console.log("Template created ", dataTemp);
          ToastSuccessMessages("template/template-successful");

          setTimeout(() => {
            navigator("/user/marketing");
          }, 2000);
        })
        .catch((ex) => {
          console.log("Exception occur, in creating template ", ex);
          AuthErrorMessages("template/template-error");
        });
    });
  };
  return (
    <div className="global-body-container marketing-create">
      <h1 className="marketing-page-title">Create Template</h1>
      <div>
        <div className="save-template-btn-container">
          <button onClick={handleSubmit} className="form-submit-button">
            Save Template
          </button>
        </div>

        <EmailEditor
          ref={emailEditorRef}
          id="editor-container"
          displayMode="web, mobile, email"
          appearance={{
            theme: "dark",
          }}
          projectId={1071}
          onLoad={onLoad}
          onReady={onReady}
          options={{
            customCSS: [
              "https://examples.unlayer.com/examples/product-library-tool/productTool.css",
            ],
            customJS: [
              window.location.protocol +
                "//" +
                window.location.host +
                "/custom2.js",
              window.location.protocol +
                "//" +
                window.location.host +
                "/custom.js",
            ],
          }}
        />
      </div>
    </div>
  );
};
